export default {
  print: {
    confirmationOfGoodsTransportation: {
      title: '货物运输确认书',
      depart: '业务部门',
      salesman: '业务员',
      sap: 'SAP号',
      detailProductModel: '规格型号',
      number: '件数',
      unitWeight: '重量（吨)',
      loadingUnitPrice: '装车费（元/吨）',
      deliveryExpense: '运费（元/吨）',
      total: '总计费用（元）',
      carrierUnit: '承运单位',
      carrierContact: '承运联系人',
      indexNum: '序号',
      carNum: '车号',
      driver: '驾驶员',
      identityNo: '身份证',
      phone: '手机',
      productInfo: '货物信息',
      pickupStorageNo: '提货仓库',
      wareContract: '仓库联系人',
      getGoodUnit: '收货单位',
      getGoodCintact: '收货联系人',
      clientName: '委托单位',
      outbound: '物流经办',
      contractTelephone: '联系电话',
      signDate: '签约日期',
      confirm: '所属部门经办确认',
      carrier: '承运经办',
      salesmanSign: '业务员已确认',
      shiptoDemand: '送货要求',
      shiptoDemandTip: '请确认盖章回传到0571-88278654',
      tip: ' 注：1.本确认书中委托、承运、收货、总包单位（其中的单位简称人并与主合同的甲乙方相对应）；2.双方对本确认书中的信息，确认真实无误并承担相应责任；3.本确认书依据合同约定执行，未尽事宜按国家相关法规办理；4.本确认书的传真机和扫描件与原件同具法律效力；5.承运货物在装卸，运输过程中造成的经济损失及安全事故责任由承运单位负责。6.承运单位承担货物',
    },
    billOfLoading: {
      title: '提货单',
      pickupNo: '提货单号',
      queryQrCode: '查询二维码',
      outboundCreateTime: '开单日期',
      validDateTo: '有效日期至',
      to: '至',
      pointOut: '请将货物发给如下提货人',
      detailProductDisplayName: '产品名称/型号/规格',
      productUnit: '计量单位',
      goodShouldSend: '应发商品',
      goodSend: '实发商品',
      number: '件数',
      unitWeight: '重量',
      total: '总计数量',
      remark: '备注',
      sap: 'SAP号',
      salesman: '业务员',
      instructionsForShipment: '发货须知',
      instructionsForShipment1:
        '1.本提货单必须盖有我司提货专用章，并经指定传真号0571-88278530、0571-88278539、0571-88278654、0571-88278600c传出，涂改无效',
      instructionsForShipment2: '2.我司提货单编号是唯一、不可重复的编号',
      instructionsForShipment3: '3.对提货单若有疑问，请咨询我司人员： 杨瑞星  0086-13735459704',
    },
    letterOfAuth: {
      title: '委托书',
      indexNum: '序号',
      carNum: '车号',
      driver: '司机',
      identityNo: '身份证号',
      phone: '电话',
      model: '型号',
      detailProductLevel: '等级',
      ton: '吨数',
    },
  },
};
